module.exports = __webpack_public_path__ + "img/Pot3.3a1ae4b8.svg";